import React, { useState, useEffect } from 'react';
import { Page, Dashboard } from '../../templates';
import { Content } from '../../organisms';
import { InfoTooltip, SelectAllCheckBox } from '../../molecules';
import { FlexBoxVertical, FlexBoxHorizontal, Label, FlexItem, Button, BackdropPanel, Typography } from '../../atoms';
import { TranslateTypography } from '../../atoms';
import palette from '../../../utils/colorPalette';
import Menu from '../../../utils/menu';
import { LanguageButton } from '../../molecules';
import i18n from '../../../utils/i18n';
import { useTranslation } from 'react-i18next';

function CadByItemPdf() {
      const { t } = useTranslation();
      const language = i18n.language;
      const [isLoading, setIsLoading] = useState(false);
      const [data, setData] = useState({});
      const [sheetList, setSheetList] = useState([]);
      const [fileList, setFileList] = useState([]);
      const [selectedSheet, setSelectedSheet] = useState('');
      const [selectedFile, setSelectedFile] = useState('');
      const [lastUpdatedTime, setLastUpdatedTime] = useState('');
      const [sesnList, setSesnList] = useState([]);
      const [selectedSesn, setSelectedSesn] = useState('');
      const url = !!selectedSheet ? 'https://static-dashff.fnf.co.kr/interstellar/cad_pdf/M/' + selectedSesn.value + '/' + selectedFile.value + '/' + selectedSheet.value : null;
      console.log('url', url)
    
      useEffect(() => {
          setIsLoading(true);
          // 페이지 로드 시 Snowflake 데이터 가져오기
          fetch('/api/cad-item-list')
            .then(response => response.json())
            .then(data => {
              console.log(data)
              setData(data);
              // 시즌 목록 생성
              const sesns = Object.keys(data.filter).map(sesn => ({
                value: sesn,
                label: sesn
              }));
              setSesnList(sesns);
              if (sesns.length > 0) {
                setSelectedSesn(sesns[0]);
              }
              
              
          
              // UTC 시간에서 9시간을 빼서 한국 시간(KST)으로 변환
              const lastModified = new Date(data.lastUpdated); // UTC 시간
        
              // 한국 시간으로 형식화
              const formattedTime = new Intl.DateTimeFormat('ko-KR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true, // 오전/오후 표시
              }).format(lastModified);
        
              setLastUpdatedTime(formattedTime); // 한국 시간 형식으로 저장
              setIsLoading(false);
            })
            .catch(error => {
              console.error('Error fetching Snowflake data:', error);
              setIsLoading(false);
            });
        }, []);

        useEffect(() => {
          if (!!selectedSesn && !!data.filter) {
            const files = data.filter[selectedSesn.value].map(file => {
              return {
                value: file,
                label: file
              }
            })
            setFileList(files)
            if (files.length > 0) {
              setSelectedFile(files[0])
            }
          }
        }, [selectedSesn])

        useEffect(() => {
          if (!!selectedFile && !!data.filter) {
            const sheets = data.result[selectedSesn.value][selectedFile.value].map(sheet => {
              return sheet
            })
            setSheetList(sheets)
            console.log('sheets', sheets)
            if (sheets.length > 0) {
              setSelectedSheet(sheets[0])
            }
          }
        }, [selectedFile])


  return (
    <Page>
      {isLoading ? <BackdropPanel /> : null}
      <Menu 
        targetPaths={['/interstellar/M/caddata', '/interstellar/M/caddata/pdf', '/interstellar/M/graphic']}
        menuItems={[
          { path: '/interstellar/M/caddata', label: 'CAD Dashboard' },
          { path: '/interstellar/M/caddata/pdf', label: 'CAD PDF View' },
          { path: '/interstellar/M/graphic', label: 'Graphic Master' }
        ]}
      />
      <LanguageButton />
      <Dashboard>
        <h1 style={{color:'#353339', margin: '30px'}}>CAD PDF View</h1>
        <Content style={{ overflow: 'auto' }}>
          <FlexBoxVertical>
            <FlexBoxHorizontal
              style={{
                height: 'auto',
                margin: '0 15px',
                width: 'calc(100% - 30px)',
                borderBottom: `1px solid ${palette.border.default}`,
                justifyContent: 'space-between',
                padding: '10px',
              }}
            >
              <Label style={{ width: '100px', margin: '15px', }}>
                <TranslateTypography variant="content2">
                  시즌 선택
                </TranslateTypography>
              </Label>
              <div style={{ width: '150px', marginRight: '10px' }}>
                <SelectAllCheckBox
                  setSelected={setSelectedSesn}
                  defaultInputValue={selectedSesn}
                  options={sesnList}
                  title="시즌"
                />
              </div>
              <Label style={{ width: '100px', margin: '15px', }}>
                <TranslateTypography variant="content2">
                  파일 선택
                </TranslateTypography>
              </Label>
              <div style={{ width: '150px', marginRight: '10px' }}>
                <SelectAllCheckBox
                  setSelected={setSelectedFile}
                  defaultInputValue={selectedFile}
                  options={fileList}
                  title="대분류"
                />
              </div>
              <Label style={{ width: '100px', margin: '15px' }}>
                <TranslateTypography variant="content2">
                  시트 선택
                </TranslateTypography>
              </Label>
              <div style={{ width: '150px' }}>
                <SelectAllCheckBox
                  setSelected={setSelectedSheet}
                  defaultInputValue={selectedSheet}
                  options={sheetList}
                  title="아이템"
                />
              </div>
              <FlexItem
                style={{
                  width: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'end',
                }}
              > <TranslateTypography variant="content2" style={{margin: '10px'}}>Last Updated : {lastUpdatedTime}</TranslateTypography>
                <InfoTooltip
                  content={`[ ctrl + 마우스 스크롤 ] 하시면 \n 화면 축소/확대 가능합니다`}
                  style={{ marginRight: '4px' }}
                />
                <a
                  href={`${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: 'none',
                    color: palette.text.default,
                  }}
                >
                  <Button
                    variant="content2"
                    style={{ width: '6rem', padding: '4px' }}
                    label="PDF 열기"
                  />
                </a>
              </FlexItem>
            </FlexBoxHorizontal>

            {isLoading ? (
              <BackdropPanel />
            ) : url ? (
              url ===
              'https://static-dashff.fnf.co.kr/interstellar/cad_pdf/M/' ? (
                <BackdropPanel />
              ) : (
                <embed
                  style={{ flex: 1, width: '100%', zoom: '1', overflow: 'auto' }}
                  src={`${url}#toolbar=0&zoom=200`}
                  type="application/pdf"
                  onLoadStart={() => setIsLoading(true)}
                  onLoad={() => setIsLoading(false)}
                  onError={() => {
                    setIsLoading(false);
                    alert(
                      'PDF를 로드하는 데 문제가 발생했습니다. 다시 시도해주세요.'
                    );
                  }}
                />
              )
            ) : (
              <FlexBoxHorizontal
                style={{
                  flex: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh',
                }}
              >
                <div>엑셀 파일 준비 중입니다.</div>
              </FlexBoxHorizontal>
            )}
          </FlexBoxVertical>
        </Content>
      </Dashboard>
    </Page>
  );
}

export default CadByItemPdf;

  

